import { MfaDeliveryMethod } from '@store/rtk/auth';
import { sessionSetter } from '@utils/storage';

export type MfaChallengeState = {
  challengeToken: string;
  availableMethods: MfaDeliveryMethod[];
  method?: MfaDeliveryMethod;
  maskedContact?: string;
  expiresAt?: string;
  remainingCodeRequests?: number;
};

const MFA_CHALLENGE_STORAGE_KEY = 'auxilium-mfa-challenge';

export const getStoredChallenge = (): MfaChallengeState | null =>
  sessionSetter.getItem<MfaChallengeState>(MFA_CHALLENGE_STORAGE_KEY);

export const setStoredChallenge = (state: MfaChallengeState) => {
  sessionSetter.setItem(MFA_CHALLENGE_STORAGE_KEY, state);
};

export const updateStoredChallenge = (patch: Partial<MfaChallengeState>) => {
  const current = getStoredChallenge();
  if (!current) return;
  setStoredChallenge({ ...current, ...patch });
};

export const clearStoredChallenge = () => {
  sessionSetter.removeItem(MFA_CHALLENGE_STORAGE_KEY);
};

export const METHOD_LABELS: Record<MfaDeliveryMethod, string> = {
  TEXT_MESSAGE: 'Text message',
  EMAIL: 'Email',
};
